/* Shows the search box's empty-state panel.

   Rules, in order of precedence:
     - any text typed        -> hide (predictive search owns the space)
     - focused and empty     -> show
     - focus leaves the field -> hide

   Deliberately not a custom element: it attaches to whatever inline search
   markup is on the page and does nothing if that markup is absent. */

(function () {
  function init(wrapper) {
    var input = wrapper.querySelector('.search-inline__input');
    var panel = wrapper.querySelector('[data-search-suggest]');
    if (!input || !panel) return;

    function sync() {
      var shouldShow = document.activeElement === input && input.value.trim() === '';
      panel.toggleAttribute('hidden', !shouldShow);
    }

    input.addEventListener('focus', sync);
    input.addEventListener('input', sync);

    // A click inside the panel must not close it before the link resolves, so
    // the check is deferred until focus has actually settled somewhere.
    input.addEventListener('blur', function () {
      setTimeout(function () {
        if (!wrapper.contains(document.activeElement)) panel.setAttribute('hidden', '');
      }, 120);
    });

    wrapper.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') panel.setAttribute('hidden', '');
    });
  }

  document.querySelectorAll('.header__search-inline').forEach(init);
})();
